// @flow

import { getFormValues } from "redux-form";
import type { State } from "@store/reducers";
import type { UserAccounts } from "@modules/service/reducer/user-accounts/types";
import { getPagination } from "@selectors";
import type { PaginationExtendedType } from "@types";

export const isLoadingUserAccounts = (state: State): boolean => {
  return state.service.userAccounts.requestsInProgress > 0;
};

export const getUserAccounts = (state: State): Array<UserAccounts> => {
  return state.service.userAccounts.list.content;
};

export const getUserAccountsPagination = (state: State): PaginationExtendedType => {
  return getPagination(state.service.userAccounts.list);
};

export const getUserAccountsFilters = (state: State) =>
  getFormValues("user-accounts-filter")(state) || {};

export const getUserAccountFilterInitialValues = (state: State) =>
  ((state.service || {}).userAccounts || {}).filterInitialValues || {};

export const getUserTypes = (state: State): Array<Object> => {
  return state.service.userAccounts.userTypes;
};
